import React, { useEffect } from "react";
import ChatWidget from "@/components/ChatWidget";

/**
 * Compact route that mounts ONLY the floating ChatWidget.
 * Used by /public/embed.js so external sites get the widget UI
 * without loading the marketing landing page.
 */
export default function WidgetEmbed() {
  useEffect(() => {
    // Force transparent background so the host site is visible around the widget
    const prevHtmlBg = document.documentElement.style.background;
    const prevBodyBg = document.body.style.background;
    const prevBodyMargin = document.body.style.margin;
    const prevBodyOverflow = document.body.style.overflow;

    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.background = prevHtmlBg;
      document.body.style.background = prevBodyBg;
      document.body.style.margin = prevBodyMargin;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);

  return (
    <div data-testid="widget-embed-root" style={{ background: "transparent" }}>
      <ChatWidget />
    </div>
  );
}
